<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-12 col-md-6">
          <h2>Data Filtering</h2>
        </div>
        <div class="col-12 col-md-6">
          <div class="rating-container float-md-right mb-3">
            <RateCapability :qAppId="qAppIdRatingValue"></RateCapability>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="filter-group col-12 col-sm-6 col-md-4 col-lg-3">
            <h5 class="filter-group-title">Universal Filters</h5>
            <div class="q-filter noHeader" id="1253f6db-3264-4b55-893e-a39ebd2e1ced"></div>
            <div class="q-filter noHeader" id="RvppW"></div>
            <div class="q-filter noHeader" id="RFLACNy"></div>
        </div>
        <div class="filter-group col-12 col-sm-6 col-md-4 col-lg-3">
          <h5 class="filter-group-title">Company Organization</h5>
          <div class="q-filter noHeader" id="3cab117b-2a2e-480a-8638-88d495a15d84"></div>
          <div class="q-filter noHeader" id="3d434b70-21eb-46a1-88ea-4fe9e510ac00"></div>
          <div class="q-filter noHeader" id="c18bdd72-663e-4cab-9b5c-1abbbda786e5"></div>
          <div class="q-filter noHeader" id="seKpB"></div>
        </div>
        <div class="filter-group col-12 col-sm-6 col-md-4 col-lg-3">
          <h5 class="filter-group-title">Calendar</h5>
          <div class="q-filter noHeader" id="UwtNP"></div>
          <div class="q-filter noHeader" id="qfsB"></div>
          <div class="q-filter noHeader" id="182a267d-f94b-4731-84a5-6467bd91a34c"></div>
        </div>
        <div class="filter-group col-12 col-sm-6 col-md-4 col-lg-3">
          <h5 class="filter-group-title">Customer</h5>
          <div class="q-filter noHeader" id="b4e4dc25-e0a8-421c-af5d-b74dc88db848"></div>
          <div class="q-filter noHeader" id="zdHTw"></div>
        </div>
        <div class="filter-group col-12 col-sm-6 col-md-4 col-lg-3">
          <h5 class="filter-group-title">Product</h5>
          <div class="q-filter noHeader" id="e89f7969-0ba7-458a-9e30-a16ee3c494a2"></div>
          <div class="q-filter noHeader" id="JFfqcp"></div>
          <div class="q-filter noHeader" id="UujMYsm"></div>
        </div>
        <div class="filter-group col-12 col-sm-6 col-md-4 col-lg-3">
          <h5 class="filter-group-title">Product Commercial Hierarchy</h5>
          <div class="q-filter noHeader" id="5e9c2db7-18da-4375-93c1-13ae780d5bcf"></div>
          <div class="q-filter noHeader" id="c4d5beff-e1c6-4588-b2b1-40ff1b5589b7"></div>
          <div class="q-filter noHeader" id="1bad803f-161f-40a5-858f-f397c3001456"></div>
          <div class="q-filter noHeader" id="bc42b795-889d-4789-a229-915b6dd15d6e"></div>
          <div class="q-filter noHeader" id="19c6cef2-97e6-42f8-a565-fab7f20129fb"></div>
          <div class="q-filter noHeader" id="9b984505-4c00-4842-bc8a-f00fbaf31f8d"></div>
          <div class="q-filter noHeader" id="a71eca7c-5f07-40cd-ad93-46548a708aa7"></div>
          <div class="q-filter noHeader" id="74ad7db4-961d-4946-a9c6-0685aebd4a23"></div>
        </div>
        <div class="filter-group col-12 col-sm-6 col-md-4 col-lg-3">
          <h5 class="filter-group-title">Product SFE Hierarchy</h5>
          <div class="q-filter noHeader" id="4cdb4346-a8d4-4bc1-869a-dd75df165e69"></div>
          <div class="q-filter noHeader" id="15519b1b-6535-4a2b-8af5-6fc38ec1551c"></div>
          <div class="q-filter noHeader" id="b4a7afd0-c166-40fe-a1e3-8059e95d0b4a"></div>
          <div class="q-filter noHeader" id="6fbd9eb2-03de-4167-8e4c-fd64d6fcdc94"></div>
        </div>
        <div class="filter-group col-12 col-sm-6 col-md-4 col-lg-3">
          <h5 class="filter-group-title">Product Bravo Hierarchy</h5>
          <div class="q-filter noHeader" id="c34bee60-e8ed-4d0b-83a1-71b8da48b286"></div>
          <div class="q-filter noHeader" id="88a27b4c-14e2-436c-8c85-e354281fdab8"></div>
          <div class="q-filter noHeader" id="NhzUMMt"></div>
          <div class="q-filter noHeader" id="XbbQx"></div>
          <div class="q-filter noHeader" id="DTjG"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.filter-group {
  margin-bottom: 20px;
}
.filter-group-title {
  margin-bottom:20px;
}
</style>
<script>
import qAPI from "../../../services/qAPI";
import page from "../../../mixins/page";

export default {
  name: "DataFiltering",
  props: [],
  mixins: [page],
  data() {
    return {
      pageName: this.$route.name,
      mashup: null,
      // Every line is a group of filters
      qObjects: "1253f6db-3264-4b55-893e-a39ebd2e1ced,RvppW,RFLACNy,"
                  + "3cab117b-2a2e-480a-8638-88d495a15d84,3d434b70-21eb-46a1-88ea-4fe9e510ac00,c18bdd72-663e-4cab-9b5c-1abbbda786e5,seKpB,"
                   + "UwtNP,qfsB,182a267d-f94b-4731-84a5-6467bd91a34c,"
                   + "b4e4dc25-e0a8-421c-af5d-b74dc88db848,zdHTw,"
                   + "e89f7969-0ba7-458a-9e30-a16ee3c494a2,JFfqcp,UujMYsm,"
                   + "5e9c2db7-18da-4375-93c1-13ae780d5bcf,c4d5beff-e1c6-4588-b2b1-40ff1b5589b7,1bad803f-161f-40a5-858f-f397c3001456,bc42b795-889d-4789-a229-915b6dd15d6e,19c6cef2-97e6-42f8-a565-fab7f20129fb,9b984505-4c00-4842-bc8a-f00fbaf31f8d,a71eca7c-5f07-40cd-ad93-46548a708aa7,74ad7db4-961d-4946-a9c6-0685aebd4a23," 
                   + "4cdb4346-a8d4-4bc1-869a-dd75df165e69,15519b1b-6535-4a2b-8af5-6fc38ec1551c,b4a7afd0-c166-40fe-a1e3-8059e95d0b4a,6fbd9eb2-03de-4167-8e4c-fd64d6fcdc94,"
                   + "c34bee60-e8ed-4d0b-83a1-71b8da48b286,88a27b4c-14e2-436c-8c85-e354281fdab8,NhzUMMt,XbbQx,DTjG",
      qFilterObjects: [
        {
          id: "hJepJT",
          nFilters: 4
        },
        { 
          id: "atmkPpt",
          nFilters: 11
        },
        { 
          id: "ERfHcD",
          nFilters: 7
        },
        { 
          id: "njc",
          nFilters: 3
        },
        { 
          id: "cTXE",
          nFilters: 2
        },
        { 
          id: "HnWkdEZ",
          nFilters: 8
        },
        { 
          id: "KLjAKX",
          nFilters: 1
        }        
      ]
    };
  },
  async mounted() {
    await this.init(this.$route, this.qObjects, this.qFilterObjects);
  },
  async destroyed() {
    qAPI.closeQlikObjectsInStore(this.qObjects.split(","));
  }
};
</script>
<style>
.q-filter.noHeader header {
  display: none;
}
</style>